import type { NoteFilters } from '../types';

/** Notes are user-scoped, never org-scoped — no `orgId` in any key. */
export const NOTE_KEYS = {
  all: ['notes'] as const,
  listInfinite: (filters: NoteFilters) => ['notes', 'list-infinite', filters] as const,
  detail: (noteId: string) => ['notes', 'detail', noteId] as const,
  history: (noteId: string, page: number) => ['notes', noteId, 'history', page] as const,
  version: (noteId: string, versionId: string) => ['notes', noteId, 'version', versionId] as const,
};
